module.exports = __webpack_public_path__ + "img/loading.588cb36b.png";